import React from 'react'

const Colorcheckbox = ({color,name}) => {
  return (
    <div className="flex items-center mr-4">
    <input   type="checkbox" value="" className="w-4 h-4 text-rose-600 checked:text-blue-400 checked:bg-rose-500 bg-green-100 rounded border border-gray-200 focus:ring-red-500  " />
    <label for="red-checkbox" className="ml-4 text-sm font-normal text-gray-jet flex items-center"><span className={`w-4 h-4 inline-block rounded-full ${color} mr-2`}></span> {name}</label>
</div>
  )
}

export default Colorcheckbox